<template>
  <div :class="$style.container">
    <img @click="prev" src="/icons/arrow-left.svg" alt="" />
    <div :class="$style.pages">
      <div
        @click="getData(i)"
        v-for="i in pagination"
        :key="i"
        :class="{ [$style.active]: i === page }"
      >
        {{ i }}
      </div>
    </div>
    <img @click="next" src="/icons/arrow-right.svg" alt="" />
  </div>
</template>

<script>
export default {
  computed: {
    pagination() {
      return this.$store.state.leads.totalPages;
    },
    page() {
      return this.$store.state.leads.thisPage;
    },
  },
  methods: {
    async getData(value) {
      const page = value;
      await this.$store.dispatch("getLeads", {
        page,
      });
      window.scrollTo({ top: 0 });
    },
    async prev() {
      if (this.page > 1) {
        const page = this.page - 1;
        await this.$store.dispatch("getLeads", {
          page,
        });
        window.scrollTo({ top: 0 });
      }
    },
    async next() {
      if (this.page !== this.pagination) {
        const page = this.page + 1;
        await this.$store.dispatch("getLeads", {
          page,
        });
        window.scrollTo({ top: 0 });
      }
    },
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem;
  .pages {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    div {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      cursor: pointer;
      &.active {
        background-color: $red;
        color: $bg-secondary;
      }
    }
  }
  img {
    cursor: pointer;
  }
}
</style>
